import os from "node:os";
import { ApplicationData } from "../applicationData";
import { setApplication } from "./application";
import { getPreloadWindow } from "./preloadAccess";
class ElectronApplication {
    mFocused;
    constructor() {
        // Track focus state via window events
        this.mFocused = true; // Assume focused initially
        // Register listeners to track focus state
        if (getPreloadWindow().api.window?.onFocus) {
            getPreloadWindow().api.window.onFocus(() => {
                this.mFocused = true;
            });
        }
        if (getPreloadWindow().api.window?.onBlur) {
            getPreloadWindow().api.window.onBlur(() => {
                this.mFocused = false;
            });
        }
    }
    get name() {
        return ApplicationData.instance.name;
    }
    get version() {
        return ApplicationData.instance.version;
    }
    get window() {
        return null;
    }
    get memory() {
        return process.getSystemMemoryInfo();
    }
    get platform() {
        return os.platform();
    }
    get platformVersion() {
        return os.release();
    }
    /**
     * returns whether the window is in focus
     */
    get isFocused() {
        return this.mFocused;
    }
    quit(exitCode) {
        getPreloadWindow().api.app.exit(exitCode);
    }
}
setApplication(new ElectronApplication());
